// SEO configuration for PortRay website
export const SEO_CONFIG = {
  default: {
    title: 'PortRay株式会社 | 転職のセンター試験 OSUMITSUKI',
    description: 'PortRay株式会社は、1次面接通過レベルの人材とだけ出会える採用サービス「転職のセンター試験 OSUMITSUKI」を提供。業界唯一のスコアリング型採用サービスで、採用効率を大幅に向上させます。',
    keywords: '転職,採用,人材紹介,営業職,面接,スコアリング,OSUMITSUKI,PortRay',
    ogImage: '/images/PortRay_ロゴ.png',
    ogType: 'website',
    twitterCard: 'summary_large_image',
    canonical: 'https://portray.co.jp',
    robots: 'index, follow',
    author: 'PortRay株式会社',
    publisher: 'PortRay株式会社'
  },
  pages: {
    home: {
      title: 'PortRay株式会社 | 評価データで人と企業の可能性を最大化',
      description: '転職のセンター試験OSUMITSUKIとスキルの通知表で、共通の評価基準を軸に採用と育成を変革。200社以上の面接基準と実務スキル評価データを統合し、評価の共通言語を提供。',
      keywords: '転職,採用,人材紹介,営業職,面接,スコアリング,OSUMITSUKI,PortRay,評価データ,スキル通知表,採用効率,育成'
    },
    company: {
      title: '会社案内 | PortRay株式会社',
      description: 'PortRay株式会社の会社概要。転職のセンター試験OSUMITSUKI、動画メディア、有料職業紹介事業を展開。2019年設立、代表取締役鹿野翔太。',
      keywords: 'PortRay,会社概要,代表取締役,鹿野翔太,有料職業紹介事業,動画メディア,2019年設立'
    },
    service: {
      title: 'サービス紹介 | 転職のセンター試験 OSUMITSUKI',
      description: '転職のセンター試験OSUMITSUKIの詳細。50以上の評価項目から詳細な経験・スキルを評価し、1次面接通過レベルの人材のみから応募が届く業界唯一の採用サービス。',
      keywords: 'OSUMITSUKI,転職のセンター試験,採用サービス,評価項目,スコアリング,1次面接,営業職,採用効率'
    },
    contact: {
      title: 'お問い合わせ | PortRay株式会社',
      description: 'PortRay株式会社へのお問い合わせフォーム。転職のセンター試験OSUMITSUKIに関するご質問、サービス導入のご相談など、お気軽にお問い合わせください。',
      keywords: 'お問い合わせ,PortRay,OSUMITSUKI,サービス導入,ご相談,お問い合わせフォーム'
    },
    content: {
      title: 'お役立ち資料 | PortRay株式会社',
      description: 'PortRay株式会社が提供するお役立ち資料。転職活動や採用に関するノウハウ、面接の実態調査など、採用・転職のプロがお届けする貴重な情報を無料でご提供。',
      keywords: 'お役立ち資料,転職活動,採用ノウハウ,面接,実態調査,無料資料,PortRay'
    },
    'content-detail': {
      title: '資料詳細 | PortRay株式会社',
      description: 'PortRay株式会社が提供するお役立ち資料の詳細ページ。転職活動や採用に関するノウハウ、面接の実態調査など、採用・転職のプロがお届けする貴重な情報を無料でダウンロード。',
      keywords: 'お役立ち資料,転職活動,採用ノウハウ,面接,実態調査,無料資料,PortRay,ダウンロード'
    },
    caseStudies: {
      title: '導入事例 | PortRay株式会社',
      description: '転職のセンター試験OSUMITSUKIの導入事例。実際にサービスを導入いただいた企業様の声、導入効果、定着率向上の実績をご紹介。',
      keywords: '導入事例,OSUMITSUKI,企業様の声,導入効果,定着率向上,実績,PortRay'
    },
    'case-study-detail': {
      title: '導入事例詳細 | PortRay株式会社',
      description: '転職のセンター試験OSUMITSUKIの導入事例詳細。実際にサービスを導入いただいた企業様の詳細なインタビュー内容をご紹介。',
      keywords: '導入事例,OSUMITSUKI,企業インタビュー,導入効果,実績,PortRay,詳細'
    },
    media: {
      title: 'メディア | PortRay株式会社',
      description: 'PortRay株式会社の最新ニュース、プレスリリース、動画コンテンツ、インタビュー記事など、メディア情報をまとめてご紹介。',
      keywords: 'メディア,ニュース,プレスリリース,動画,インタビュー,PortRay,OSUMITSUKI,最新情報'
    },
        recruit: {
          title: '採用情報 | PortRay株式会社',
          description: 'PortRay株式会社の採用情報。一緒に"評価の共通言語"をつくる仲間を募集しています。セールス、カスタマーサクセス、コンテンツディレクターなど様々な職種で募集中。',
          keywords: '採用情報,PortRay,求人,セールス,カスタマーサクセス,コンテンツディレクター,転職,キャリア'
        },
        'osumitsuki-score': {
          title: 'OSUMITSUKI Score | 社会で共通の人材評価プラットフォーム',
          description: 'OSUMITSUKI Scoreは人材の実力を可視化し、企業と個人の成長を加速させる人材評価指標プラットフォーム。30項目以上の共通評価基準で採用・育成・配置・昇格を支援。',
          keywords: 'OSUMITSUKI Score,人材評価,共通評価基準,キャリアアセッサー,採用,育成,スコアリング,PortRay'
        },
        privacy: {
          title: 'プライバシーポリシー | PortRay株式会社',
          description: 'PortRay株式会社のプライバシーポリシー。個人情報の取り扱い方針について定めています。',
          keywords: 'プライバシーポリシー,個人情報保護,PortRay'
        },
        notFound: {
          title: 'ページが見つかりません | PortRay株式会社',
          description: 'お探しのページは見つかりませんでした。',
          keywords: ''
        }
  }
};

// Structured data for organization
export const ORGANIZATION_STRUCTURED_DATA = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "PortRay株式会社",
  "alternateName": "PortRay Inc.",
  "url": "https://portray.co.jp",
  "logo": "https://portray.co.jp/images/PortRay_ロゴ.png",
  "description": "転職のセンター試験OSUMITSUKIを提供する採用サービス企業",
  "foundingDate": "2019-03",
  "founder": {
    "@type": "Person",
    "name": "鹿野翔太"
  },
  "foundingLocation": {
    "@type": "Place",
    "name": "東京都港区"
  },
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "北青山２丁目１２番８号 BIZSMART",
    "addressLocality": "港区",
    "addressRegion": "東京都",
    "postalCode": "107-0061",
    "addressCountry": "JP"
  },
  "contactPoint": {
    "@type": "ContactPoint",
    "contactType": "customer service",
    "url": "https://portray.co.jp/contact"
  },
  "sameAs": [
    "https://osumitsuki-b.studio.site/"
  ]
};

// Structured data for service
export const SERVICE_STRUCTURED_DATA = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "転職のセンター試験 OSUMITSUKI",
  "description": "1次面接通過レベルの人材とだけ出会える採用サービス",
  "provider": {
    "@type": "Organization",
    "name": "PortRay株式会社"
  },
  "serviceType": "人材紹介・採用支援",
  "areaServed": {
    "@type": "Place",
    "name": "東京都、神奈川県、埼玉県、千葉県"
  },
  "offers": {
    "@type": "Offer",
    "description": "営業職に特化した採用サービス"
  }
};

// Structured data for website
export const WEBSITE_STRUCTURED_DATA = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "PortRay株式会社",
  "url": "https://portray.co.jp",
  "description": "転職のセンター試験OSUMITSUKIを提供する採用サービス企業の公式サイト",
  "publisher": {
    "@type": "Organization",
    "name": "PortRay株式会社"
  },
  "potentialAction": {
    "@type": "SearchAction",
    "target": "https://portray.co.jp/search?q={search_term_string}",
    "query-input": "required name=search_term_string"
  }
};
